import { useSelector } from 'react-redux';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectBuilder } from '../../selectors/builder';
import { ReliableBlock } from '../../components/ReliableBlock';
import { trackButtonClick } from './tracking';
import * as React from 'react';
import { isReliableBuilder } from '../../utils/builder';

export const ReliableBlockContainer = () => {
  const { config } = useApplicationContext();
  const { id } = useSelector(selectBuilder);

  if (!isReliableBuilder(id, config)) {
    return null;
  }

  return <ReliableBlock onClick={trackButtonClick} />;
};
